"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var UpperCaseSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4.5,7.63600094 L3.70679672,9.74988694 L5.29279672,9.74988694 L4.5,7.63600094 Z M12.5,7.63600094 L11.7067967,9.74988694 L13.2927967,9.74988694 L12.5,7.63600094 Z M0.797753117,13.2366574 L3.65730374,5.61118909 C3.94139099,4.84136963 5.06611633,4.84136963 5.34269626,5.61118909 L8.20224688,13.2366574 L8.20224688,13.2366574 C8.49647306,14.1050817 7.25285685,14.7439381 6.79775312,13.7633426 L5.85479672,11.2498869 L5.85479672,11.2498869 L3.14479672,11.2498869 L2.20224688,13.7633426 L2.20224688,13.7633426 C1.78026399,14.7130922 0.476684104,14.1369563 0.797753117,13.2366574 Z M8.79775312,13.2366574 L11.6573037,5.61118909 C11.941391,4.84136963 13.0661163,4.84136963 13.3426963,5.61118909 L16.2022469,13.2366574 L16.2022469,13.2366574 C16.4964731,14.1050817 15.2528569,14.7439381 14.7977531,13.7633426 L13.8547967,11.2498869 L13.8547967,11.2498869 L11.1447967,11.2498869 L10.2022469,13.7633426 L10.2022469,13.7633426 C9.78026399,14.7130922 8.4766841,14.1369563 8.79775312,13.2366574 Z" })));
};
UpperCaseSmall.displayName = 'UpperCaseSmall';
exports.default = UpperCaseSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UpperCaseSmall.js.map